import { Attributes, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../../TemporalEntity';

@NeoModel
export default class SARSIDType extends TemporalEntity {
    static typeName = "SARSIDType";

    public sarsidTypeId: number = 0;

    @Attributes.Display("Code")
    @Rules.StringLength(3)
    @Rules.Required()
    public sarsidTypeCode: string = "";

    @Rules.Required()
    @Rules.StringLength(120)
    public description: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.sarsidTypeCode) {
            return "New sarsid type";
        } else {
            return this.sarsidTypeCode;
        }
    }
}